import React, { useState, useEffect, useContext } from 'react';
import { string, bool, shape } from 'prop-types';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import { useLayoutGroupProps } from '@thd-olt-component-react/layout-manager';
import { Carousel } from '@thd-olt-component-react/carousel';
import { useHelmet, LinkTag } from '@thd-nucleus/thd-helmet';

import './banner.style.scss';
import { makeApiRequest } from '../request';

import {
  getSchema, isServer, haveProductsChanged, getSkus, getDefaultBanner, shouldMakeApiRequest, isExperienceDataResolved
} from '../helpers';

const hoistedImgFunction = ({ data }) => {
  const { isBrowse, preload, defaultBannerInfo } = data;
  if (isBrowse && preload) {
    return [
      new LinkTag({ rel: 'preload', as: 'image', href: defaultBannerInfo.imgSrc, id: 'spBannerPreloadLink' })
    ];
  }
  return null;
};

const SponsoredBanner = (props) => {
  const [lastRequestScenario, setLastRequestScenario] = useState({});
  const [hasData, setHasData] = useState(false);
  const { renderNewBanner = false } = useLayoutGroupProps({ props });
  const experienceContext = useContext(ExperienceContext);
  const { pageContext, preload } = props;
  let { schema } = props;

  const { storeId, isLocalized } = useStore({
    varnish: true,
    online: true
  });

  experienceContext.useStoreId = storeId;

  const defaultBannerInfo = getDefaultBanner(experienceContext);
  schema = getSchema({ schema, pageContext });
  const schemaId = schema + '__banner';

  const data = {
    preload,
    channel: experienceContext.channel,
    isBrowse: pageContext.isBrowse,
    defaultBannerInfo
  };
  useHelmet('preloadBanner', { data }, hoistedImgFunction);

  useEffect(() => {
    const isResolvedContext = isExperienceDataResolved({ isLocalized, experienceContext });
    if (renderNewBanner && isResolvedContext) {
      const isValidScenario = shouldMakeApiRequest({ lastRequestScenario, experienceContext, pageContext });

      if (isValidScenario) {
        setLastRequestScenario({
          url: window.location.pathname + window.location.search,
          skus: getSkus(pageContext)
        });

        makeApiRequest({
          schema, schemaId, experienceContext, pageContext, setHasData
        });
      }
    }
  }, [pageContext.data, isLocalized, experienceContext.mounted]);

  if (!renderNewBanner) {
    return null;
  }

  return (
    <div className="sponsored_banner_container" style={defaultBannerInfo.bgCss}>
      {!hasData && (
        <div id="default_banner_carousel" style={defaultBannerInfo.spacingCss}>
          <a href={defaultBannerInfo.href}>
            { /* eslint-disable-next-line */}
            <img width="100%" src={defaultBannerInfo.imgSrc} style={{ position: 'absolute', top: 0, left: 0 }} />
          </a>
        </div>
      )}

      {hasData && (
        <Carousel multiItem={false} totalItems={2}>
          <div id="default_banner_carousel" style={defaultBannerInfo.spacingCss}>
            <a href={defaultBannerInfo.href}>
              { /* eslint-disable-next-line */}
              <img width="100%" src={defaultBannerInfo.imgSrc} style={{ position: 'absolute', top: 0, left: 0 }} />
            </a>
          </div>
          <div id={schemaId} className="nucleus-banner" data-usenewimpressionlogic="true" />
        </Carousel>
      )}
    </div>
  );
};

SponsoredBanner.propTypes = {
  schema: string,
  pageContext: shape({
    label: string,
    data: shape(),
    keyword: string,
    isSearch: bool,
    isCategory: bool,
    isBrowse: bool
  }),
  preload: bool
};

SponsoredBanner.defaultProps = {
  schema: '',
  pageContext: {},
  preload: true
};

export { SponsoredBanner };
